<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)" v-if="user && user.IDStB">
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text">{{ title }}</div>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Sede del trámite</label>
            <v-select v-model="sede" :items="sedes" item-text="sede.nombre" item-value="sede.IDF"
              label="Selecciona la sede" persistent-hint return-object single-line v-on:change="loadData">
            </v-select>
          </v-col>
        </v-row>
        <div v-if="pagos.length > 0"><br />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    #
                  </th>
                  <th class="text-left">
                    Concepto
                  </th>
                  <th class="text-left">
                    Monto
                  </th>
                  <th class="text-left">
                    Forma de pago
                  </th>
                  <th class="text-left">
                    Pagado Anterior
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pagoData,
                  pagoKey) in pagos" :key="pagoKey">
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.IDF }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.Concepto }}</td>
                  <td v-bind:style="colorText(pagoData)">${{ pagoData.Monto }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.forma_de_pago_data.Nombre }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.ultimo_pago == '' ? '-' : pagoData.ultimo_pago }}
                  </td>

                  <td>
                    <v-btn color="success" elevation="7" large v-on:click="examen = true"
                      @click="createCobranza(pagoData.IDF)">Pagar</v-btn>
                    <!-- <strong v-else>Pagado</strong> -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
//  v-if="pagoData.pagadoAlumno == 0"
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "PaymentRegular",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: function () {
    return {
      title: "Efectuar pago",
      sede: { text: '', value: '' },
      sedes: [],
      pagos: [],
      total: 0,
      items: [],
      urlPay: '',
    }
  },

  methods: {
    async loadData() {
      console.log(this.sede)
      this.$API
        .get({
          url: "alumno-pagos-regulares?alumno=" + this.user.IDStB + "&sede=" + this.sede.sede.IDF,
          data: {},
        })
        .then((res) => {
          console.log(res)
          this.pagos = res;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    colorText(pagoData) {
      let color = 'black';
      if (pagoData.block) {
        color = '#888';
      }
      if (pagoData.pagado) {
        color = 'green';
      }
      return { color: color }
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    changeTotal(pagoData, index) {
      console.log(pagoData)
      pagoData.index = index;
      if (pagoData.check) {
        this.total += pagoData.precioAPagar;
      } else {
        this.total -= pagoData.precioAPagar;
      }
      let selecteds = this.pagos.items.filter(d => { return d.check; })
      this.items = selecteds.map((value) => { return { id: value.IDStB, monto: value.precioAPagar, index: value.index } })
      console.log(this.items)
    },

    async createCobranza(id) {
      let dataSend = {
        alumno: this.user.IDStB,
      };

      let url = "pago-concepto-regular/" + id;

      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          //Se crea la cobranza primero
          if (res.id) {
            this.pay(res)
          } else {
            alert('Pago en revisión')
          }

        });
    },
    async pay(res) {
      await this.$API
        .post({
          url: "alumno-pagos-regulares-pay/" + res.id,
          data: res
        }).then((resUrl) => {
          console.log(resUrl)
          location.href = resUrl
        });
    },
  },

  mounted() {
    this.$API
      .get({
        url: "alumno-sedes/" + this.user.IDStB,
        data: {},
      })
      .then((res) => {
        this.sedes = res;
      })
      .catch((err) => {
        console.log(err);
      });
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>
